export const langReplace = Object.freeze({
  no: 'da',
});
